import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeDeleteUserIntegrationModal, fetchDeleteUserIntegration, selectIsDeleteUserIntegrationModalOpen, selectOnDelete } from "../../model"

export const DeleteUserIntegrationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsDeleteUserIntegrationModalOpen)
    const onDelete = useAppSelector(selectOnDelete)

    const handleClose = () => {
        dispatch(closeDeleteUserIntegrationModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        await new Promise((res, rej) => {
            dispatch(fetchDeleteUserIntegration())
                .unwrap()
                .then(() => {
                    notify.success('Пользовательская интеграция успешно удалена')
                    reset()
                    onDelete?.()
                    handleClose()
                    res('')
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title={(
                <div>
                    Удаление <br />
                    Пользовательской <br />
                    Интеграции
                </div>
            )}
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите удалить пользовательскую интеграцию?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Удалить
                    </button>
                </div>
            </form>
        </Modal>
    )
}